import { groupBy } from 'lodash';
import { ITemplate } from 'types/dto';
import { SelectGroupSeparator } from 'components/SelectGroupSeparator';
import { MenuItem } from '@mui/material';

export function renderGroupedTemplatesMenuItems(templates: ITemplate[]) {
  const grouped = Object.values(groupBy(templates, 'category'));

  return grouped
    .map((templates, index) => [
      ...templates.map(template => (
        <MenuItem key={template.id} value={template.id}>
          {template.name}
        </MenuItem>
      )),
      index < grouped.length - 1 && <SelectGroupSeparator key={index} />,
    ])
    .flat();
}
